export const NoResultsItemStyles = {
  container: 'flex px-3 py-3',
  icon: 'text-blue300 mr-3',
  text: 'text-gray900',
}
